import { DEFAULT_SIDEBAR_TAB } from 'redux/modules/journeys/constants';
import { pendingStatuses } from 'utils/journey';
import { SERVICES } from 'tenant/config';

/**
 * @param path {string}
 * @returns {string || undefined}
 */
export function getIdFromUrl(path) {
  if (typeof path !== 'string') return;

  try {
    const result = path.match(/\/tasks\/(\d+)/);

    if (Array.isArray(result)) return result[1];
  } catch (e) {
    console.error('problem getting id from url: ', e);
  }
}

export function getDetailSidebarTab({ tasks, journeyStatus }) {
  const groupContainsChatTask =
    SERVICES.ZENDESK && tasks?.some((task) => task.task_type === 'TASK_TYPE_OPEN_CHAT');
  const hasDriver = !pendingStatuses.includes(journeyStatus);

  return groupContainsChatTask && hasDriver ? 'CHAT' : DEFAULT_SIDEBAR_TAB;
}
